import {
  Car,
  Motorcycle,
  Package,
  Truck
} from "@phosphor-icons/react";

export const VehicleSlider = () => {
  const vehicles = [
    {
      icon: Motorcycle,
      name: "Two-Wheeler",
      payload: "Up to 20 kg",
      bestFor: "Small tools, documents, urgent site items",
      color: "#0055FF",
    },
    {
      icon: Car,
      name: "Pickup 7ft",
      payload: "Up to 750 kg",
      bestFor: "Hardware, paint, plumbing, light material",
      color: "#0055FF",
    },
    {
      icon: Truck,
      name: "Mini Truck",
      payload: "Up to 1.5 tons",
      bestFor: "Cement bags, tiles, blocks, packaged loads",
      color: "#0055FF",
    },
    {
      icon: Truck,
      name: "Tipper",
      payload: "Bulk loads",
      bestFor: "Sand, aggregate, M-sand, jelly",
      color: "#FF5500",
    },
    {
      icon: Package,
      name: "Heavy Vehicle",
      payload: "Project loads",
      bestFor: "Steel, machinery, high-volume supply",
      color: "#FF5500",
    }
  ];

  return (
    <section
      id="vehicles"
      data-testid="vehicle-slider-section"
      className="py-16 lg:py-24 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 mb-4">
            <Truck size={20} weight="duotone" className="text-[#0055FF]" />
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#0055FF]">
              Vehicle Network
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-black text-[#0F172A] mb-4">
            Match the vehicle to the material.
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            From small site items to bulk civil material, Loado is structured
            around vehicle categories construction teams actually use.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5 lg:gap-6">
          {vehicles.map((vehicle, index) => (
            <div
              key={vehicle.name}
              data-testid={`vehicle-card-${index}`}
              className="flex flex-col text-center p-5 bg-slate-50 rounded-lg border border-slate-200 hover:border-slate-300 hover:shadow-md transition-all min-h-[220px]"
            >
              <div
                className="w-16 h-16 flex items-center justify-center rounded-full mb-4 mx-auto"
                style={{ backgroundColor: `${vehicle.color}15` }}
              >
                <vehicle.icon size={32} weight="duotone" style={{ color: vehicle.color }} />
              </div>

              <h3 className="text-base font-bold text-[#0F172A] mb-2">{vehicle.name}</h3>
              <p className="text-sm font-semibold text-slate-700 mb-2">{vehicle.payload}</p>
              <p className="text-xs text-slate-500 leading-relaxed">{vehicle.bestFor}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-slate-500 text-sm">
            Chennai availability first, with category expansion as partner onboarding grows.
          </p>
        </div>
      </div>
    </section>
  );
};
